export default {
    icon: '',
    splashes: {
        ios: {},
        android: {}
    },
    cordovaConfig: '',  // xml string
    iosCred: {
        // '开发包': {
        //     team_id       string 团队 ID
        //     common_name   string 证书名
        //     cert_expires  string 证书过期时间
        //     name          string 描述文件 name
        //     uuid          string 描述文件 UUID
        //     bundle_id     string 描述文件应用 ID
        //     expires       string 描述文件过期时间
        // }
    },
    androidCred: {
        // '开发包': {
        //     cert: '',
        //     sign: ''
        // }
    },
    engines: {
        ios: [],
        android: []
    },
    currentEngine: {
        ios: '',
        android: ''
    },
    hooks: [],
    plugins: [],
    pluginStatus: true, // 所有插件的安装状态，true 为安装成功
    appVersions: [],    // 应用版本，筛选用
    buildList: []
}
